// Synthesised applause (no audio file): many short filtered noise claps over ~4s.
export const playApplause = (seconds = 4) => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  const len = Math.floor(ctx.sampleRate * 0.06);
  const buf = ctx.createBuffer(1, len, ctx.sampleRate);
  const ch = buf.getChannelData(0);
  for (let i = 0; i < len; i += 1) ch[i] = (Math.random() * 2 - 1) * Math.exp(-i / (len / 6));
  const master = ctx.createGain();
  master.connect(ctx.destination);
  const t0 = ctx.currentTime;
  master.gain.setValueAtTime(0, t0);
  master.gain.linearRampToValueAtTime(0.7, t0 + 0.4);
  master.gain.setValueAtTime(0.7, t0 + seconds - 1.2);
  master.gain.linearRampToValueAtTime(0, t0 + seconds);
  const claps = Math.floor(seconds * 70);
  for (let i = 0; i < claps; i += 1) {
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.playbackRate.value = 0.8 + Math.random() * 0.5;
    const f = ctx.createBiquadFilter();
    f.type = 'bandpass';
    f.frequency.value = 900 + Math.random() * 1800;
    f.Q.value = 0.8;
    const g = ctx.createGain();
    g.gain.value = 0.15 + Math.random() * 0.35;
    src.connect(f).connect(g).connect(master);
    src.start(t0 + Math.random() * seconds);
  }
  setTimeout(() => ctx.close(), (seconds + 0.5) * 1000);
};
